import { render, staticRenderFns } from "./MetadataImportInterface.vue?vue&type=template&id=8eb73d22"
import script from "./MetadataImportInterface.vue?vue&type=script&lang=js"
export * from "./MetadataImportInterface.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports